<script>
import axios from 'axios'
import PayPage from './components/PayPage.vue'

const API_BASE = process.env.VUE_APP_API_BASE || ''

export default {
    name: 'App',
    components: { PayPage },

    data() {
        return {
            state: 'loading',
            transaction: null,
            errorMessage: '',
            apiBase: API_BASE
        }
    },

    async mounted() {
        const gtid = window.location.pathname.split('/').filter(Boolean)[0]

        if (!gtid) {
            this.errorMessage = 'Invalid payment link'
            this.state = 'error'
            return
        }

        try {
            const statusRes = await axios.get(`${API_BASE}/status/${gtid}`)
            const resultMessage = statusRes.data.resultMessage
            const resultCode = statusRes.data.resultCode

            await this.getInfo(gtid)

            if (resultMessage === null) {
                await this.sendOtp()
            } else if (resultMessage === 'CREATED' || resultMessage === 'INVALID_PIN' || resultMessage === 'TELECOM_CONFIRM_FAILED') {
                this.state = 'ready'
            } else {
                this.errorMessage = this.statusMessage(resultCode)
                this.state = 'error'
            }
        } catch (error) {
            const code = error.response?.data?.resultCode
            this.errorMessage = this.statusMessage(code)
            this.state = 'error'
        }
    },

    methods: {
        async getInfo(gtid) {
            const res = await axios.get(`${API_BASE}/get-info/${gtid}`)
            this.transaction = res.data
        },
        async sendOtp() {
            try {
                const res = await axios.post(`${API_BASE}/w-create`, {
                    msisdn: this.transaction.msisdn,
                    gtid: this.transaction.gtid,
                })
                if (!res.data.success) {
                    this.errorMessage = this.statusMessage(res.data.resultCode)
                    this.state = 'error'
                    return
                }
                this.state = 'ready'
            } catch (error) {
                const code = error.response?.data?.resultCode
                this.errorMessage = this.statusMessage(code)
                this.state = 'error'
            }
        },

        statusMessage(code) {
            const messages = {
                601: 'Operation not found',
                602: 'Invalid PIN code',
                603: 'Operator error, please try again later',
                604: 'Request timed out, please try again later',
                605: 'Insufficient funds or reservation error',
                606: 'Deduction error, please contact support',
                607: 'PIN resend requested too frequently',
                608: 'Not enough balance',
                609: 'Subscriber not found',
            }
            return messages[code] || 'Unknown error, please contact support'
        }
    }
}
</script>

<template>
  <div class="relative w-full min-h-screen overflow-hidden bg-[#033330]">
    <div class="pointer-events-none absolute -top-32 -left-24 w-96 h-96 rounded-full bg-[#0a5f5a] opacity-30 blur-3xl"></div>
    <div class="pointer-events-none absolute -bottom-40 -right-24 w-[28rem] h-[28rem] rounded-full bg-[#073938] opacity-50 blur-3xl"></div>

    <div v-if="state === 'loading'" class="relative flex items-center justify-center min-h-screen">
      <svg class="animate-spin h-8 w-8 text-white" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
      </svg>
    </div>

    <div v-else-if="state === 'error'" class="relative flex flex-col items-center justify-center min-h-screen text-center px-6 space-y-3">
      <p class="font-medium text-xl text-white">Failed to load payment</p>
      <p class="text-sm text-white/60">{{ errorMessage }}</p>
    </div>

    <PayPage
      v-else
      class="relative"
      :transaction="transaction"
      :api-base="apiBase"
    />

  </div>
</template>
